import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text } from '@bigcommerce/big-design';

import { markPOIssued } from '../../redux/actions/purchaseOrders';

const IssueModal = ({ payload, showIssueModal, setShowIssueModal, purchaseOrder, issuePo }) => {
  const update = () => {
    issuePo(payload, purchaseOrder.id);
    setShowIssueModal(false);
  }

  return(
    <>
      { purchaseOrder &&
        <Modal
          actions={[
            {
              text: 'Cancel',
              variant: 'subtle',
              onClick: () => setShowIssueModal(false),
            },
            { text: 'Issue Purchase Order', onClick: () => update() },
          ]}
          closeOnClickOutside={true}
          closeOnEscKey={true}
          header="Issue Purchase Order"
          isOpen={showIssueModal}
          onClose={() => setShowIssueModal(false)}
        >
          <H3>{purchaseOrder.invoice_number || purchaseOrder.id}</H3>
          <Text>Confirm that this PO has been issued to the supplier?</Text>
        </Modal>
      }
    </>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  issuePo: (payload, purchaseOrderId) => dispatch(markPOIssued(payload, purchaseOrderId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IssueModal);